@if (isAuthoring) {
  <section>
    <mat-accordion class="example-headers-align" multi>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Inspect: {{ contentGroup }}
          </mat-panel-title>
          <mat-panel-description>
            <button mat-raised-button color="primary" (click)="hideInspector()">Hide Inspector</button>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <p>This will only appear in Authoring mode!</p>
        <table>
          <tr>
            <th>Key </th>
            <th>Value</th>
          </tr>
          @for (content of displayContent | keyvalue; track content) {
            <tr>
              <td>
                {{ content.key }}
              </td>
              <td>
                {{ content.value }}
              </td>
            </tr>
          }
        </table>
      </mat-expansion-panel>
    </mat-accordion>
  </section>
}